import {
  ADD_PARTNER_STAFF,
  EDIT_PARTNER_STAFF,
  DELETE_PARTNER_STAFFS,
  SET_PAGE_DATA,
  SET_TOTAL_RECORDS,
  SET_PAGE,
  PARTNER_STAFFS_LOADING,
  PARTNER_STAFFS_FAILURE,
  GET_PARTNER_STAFFS,
  SET_REDIRECT_URL,
GET_ALL_STAFF_BRANCH
} from "./partner-staff-constant";
import {
  handleLoading,
  handleFailure,
  handleSetRedirectUrl,
  handleGetData,
  handleSetTotalRecords,
  handleSetPage,
  handleEditItem,
  handleAddItem,
  handleDeleteItems,
} from "../utils/reducerUtils";

// Initial state
const initialState = {
  staffList: {},
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  error: null,
  redirectTo: false,
};

export const partnerStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case PARTNER_STAFFS_LOADING:
      return handleLoading(state, action);

    case PARTNER_STAFFS_FAILURE:
      return handleFailure(state, action);

    case SET_REDIRECT_URL:
      return handleSetRedirectUrl(state, action);

    case GET_PARTNER_STAFFS:
      return handleGetData(state, action, "staffList");

    case SET_TOTAL_RECORDS:
      return handleSetTotalRecords(state, action);

    case SET_PAGE:
      return handleSetPage(state, action);

    case EDIT_PARTNER_STAFF:
      return handleEditItem(state, action, "staffList", "partnerStaffId");

    case ADD_PARTNER_STAFF:
      return handleAddItem(state, action, "staffList", "partnerStaffId");

    case DELETE_PARTNER_STAFFS:
      return handleDeleteItems(state, action, "staffList", "partnerStaffId");
    default:
      return state;
  }
};
